/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type OneOnOneAutopilotQueryVariables = {};
export type OneOnOneAutopilotQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"OneOnOneAutopilot_viewer">;
    };
};
export type OneOnOneAutopilotQuery = {
    readonly response: OneOnOneAutopilotQueryResponse;
    readonly variables: OneOnOneAutopilotQueryVariables;
};



/*
query OneOnOneAutopilotQuery {
  viewer {
    ...OneOnOneAutopilot_viewer
    id
  }
}

fragment AutopilotFlexibility_event on Event {
  eventParentRelayId
  attendeePeople {
    __typename
    ... on PersonList {
      list {
        id
        emails
        primaryEmail
        profile {
          givenName
          familyName
          externalImageUrl
        }
        isYou
      }
    }
  }
  eventKey {
    id
    externalEventId
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
        subjectValue
        lastModified
      }
    }
    id
  }
  annotatedRecurringEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
        subjectValue
        lastModified
      }
    }
    id
  }
  suggestedAutopilotSettingsResponseV3 {
    __typename
    ... on SuggestedAutopilotSettingsResponseV3 {
      intersectionOfAttendeesMeetingHours {
        minSlot {
          dayOffset
          timeSlot
        }
        maxSlot {
          dayOffset
          timeSlot
        }
      }
      calendarIdToMeetingHours {
        calendarId
        dayOffsetTimeSlotRanges {
          minSlot {
            dayOffset
            timeSlot
          }
          maxSlot {
            dayOffset
            timeSlot
          }
        }
      }
      suggestedAutopilotSettings {
        isRoomFlexible
        movementType
        allowedEndTime {
          dayOffset
          timeSlot
        }
        allowedStartTime {
          dayOffset
          timeSlot
        }
      }
    }
    ... on GraphEntityError {
      message
    }
  }
  moveRangeInLocalTimeV3 {
    __typename
    ... on MoveRangeInLocalTimeV3 {
      allowedStartTimeInclusive {
        dayOffset
        timeSlot
      }
      allowedEndTimeInclusive {
        dayOffset
        timeSlot
      }
    }
    ... on GraphEntityError {
      message
    }
  }
}

fragment AutopilotFlexibility_org on Org {
  userWorkingHours(resolveOverrides: false) {
    workingHours {
      id
      type
      timeZone
      daySettings {
        day
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
      dayOverrides {
        date
        setting {
          minSlot
          maxSlot
          excludedSlots
        }
      }
    }
    id
  }
}

fragment EventSummaryAttendees_attendees on Attendee {
  displayName
  urnValue
  profileId
  urnType
}

fragment EventSummaryAttendees_org on Org {
  id
  domains
}

fragment EventSummaryAutopilotFlex_event on Event {
  annotatedEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
      }
    }
    id
  }
  annotatedRecurringEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
      }
    }
    id
  }
}

fragment EventSummaryBestTimeRecurrence_event on Event {
  startTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  endTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  recurrenceRules {
    firstInstanceStartTime {
      type
      dateOrDateTime
      timeZone
      millis
      offsetMinutes
    }
    timeZone
    interval {
      interval
      byDay
      bySetPos
      freqType
      count
      untilTime {
        type
        dateOrDateTime
        timeZone
        millis
        offsetMinutes
      }
    }
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
      }
    }
    id
  }
  annotatedRecurringEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
      }
    }
    id
  }
}

fragment EventSummaryExternalAttendees_attendees on Attendee {
  displayName
  urnValue
  profileId
  urnType
}

fragment EventSummaryExternalAttendees_org on Org {
  id
  domains
}

fragment EventSummaryRecurrence_event on Event {
  isAllDay
  startTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  endTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  eventKey {
    externalEventId
    id
  }
  eventFlexibilityErrorable {
    __typename
    ... on EventFlexibilityNewList {
      list {
        flex
        flexString
      }
    }
  }
  recurrenceRules {
    firstInstanceStartTime {
      type
      dateOrDateTime
      timeZone
      millis
      offsetMinutes
    }
    timeZone
    interval {
      interval
      byDay
      bySetPos
      freqType
      count
      untilTime {
        type
        dateOrDateTime
        timeZone
        millis
        offsetMinutes
      }
    }
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
      }
    }
    id
  }
}

fragment EventSummaryRecurrence_org on Org {
  id
  primaryOrgCalendar
}

fragment EventSummaryRoom_attendees on Attendee {
  displayName
  urnValue
}

fragment EventSummaryTime_event on Event {
  startTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  endTime {
    type
    dateOrDateTime
    timeZone
    millis
    offsetMinutes
  }
  eventKey {
    externalEventId
    id
  }
  eventFlexibilityErrorable {
    __typename
    ... on EventFlexibilityNewList {
      list {
        flex
        flexString
      }
    }
  }
  recurrenceRules {
    firstInstanceStartTime {
      type
      dateOrDateTime
      timeZone
      millis
      offsetMinutes
    }
    timeZone
    interval {
      interval
      byDay
      bySetPos
      freqType
      count
      untilTime {
        type
        dateOrDateTime
        timeZone
        millis
        offsetMinutes
      }
    }
  }
  annotatedEvent {
    orgTags {
      tag
      state {
        active
        value
        subjectType
      }
    }
    id
  }
}

fragment EventSummaryTime_org on Org {
  id
  primaryOrgCalendar
}

fragment OnboardingAutopilotEvent_event on Event {
  ...EventSummaryRecurrence_event
  ...EventSummaryTime_event
  ...EventSummaryBestTimeRecurrence_event
  ...EventSummaryAutopilotFlex_event
  ...AutopilotFlexibility_event
  isClockwiseEvent
  calendarIds
  eventKey {
    id
    calendarIds
    externalEventId
    hashedCalendars
    orgId
  }
  organizerPerson {
    __typename
    ... on Person {
      isYou
      primaryEmail
    }
    ... on Node {
      __isNode: __typename
      id
    }
  }
  attendees {
    ...EventSummaryAttendees_attendees
    ...EventSummaryExternalAttendees_attendees
    ...EventSummaryRoom_attendees
    displayName
    profileId
    optional
    organizer
    resource
    responseStatus
    urnType
    urnValue
  }
  creator {
    displayName
    profileId
    optional
    organizer
    resource
    responseStatus
    urnType
    urnValue
  }
  endTime {
    millis
    timeZone
    offsetMinutes
  }
  organizer {
    displayName
    profileId
    optional
    organizer
    resource
    responseStatus
    urnType
    urnValue
  }
  recurringEventId
  recurrenceRules {
    firstInstanceStartTime {
      timeZone
      offsetMinutes
    }
    timeZone
    interval {
      byDay
      count
    }
    cancelledInstances
  }
  startTime {
    millis
    timeZone
    offsetMinutes
  }
  title
  transparency
  isAllDay
  guestsCanInviteOthers
  guestsCanModify
  guestsCanSeeOtherGuests
  locked
  privateCopy
  description
  location
  etag
  htmlLink
  hangoutLink
  annotatedEvent {
    id
    externalEventId
    orgTags {
      tag
      state {
        lastModified
        subjectType
        subjectValue
        active
        value
      }
    }
    userTags {
      tag
      count
      states {
        lastModified
        subjectType
        subjectValue
        active
        value
      }
    }
  }
  createdMillis
  featureStatesForOrganizer {
    __typename
    ... on FeatureStates {
      mixedFreemiumOrgUIState {
        autopilotPaused
        moveRangesEnabled
      }
    }
    ... on GraphEntityError {
      statusCode
      message
    }
  }
}

fragment OnboardingAutopilotEvent_org on Org {
  id
  domains
  experiments
  ...EventSummaryAttendees_org
  ...EventSummaryExternalAttendees_org
  ...EventSummaryRecurrence_org
  ...EventSummaryTime_org
  ...AutopilotFlexibility_org
}

fragment OneOnOneAutopilot_viewer on Viewer {
  id
  user {
    id
    orgs(first: 1000000) {
      edges {
        node {
          ...OnboardingAutopilotEvent_org
          id
          experiments
          focusTimeSavedInHours
          primaryOrgEmail
          primaryOrgCalendar
          oneOnOnesForCalendar {
            __typename
            ... on EventList {
              list {
                ...OnboardingAutopilotEvent_event
                moveRangeInLocalTimeV3 {
                  __typename
                  ... on MoveRangeInLocalTimeV3 {
                    allowedStartTimeInclusive {
                      dayOffset
                      timeSlot
                    }
                    allowedEndTimeInclusive {
                      dayOffset
                      timeSlot
                    }
                  }
                  ... on GraphEntityError {
                    message
                  }
                }
                eventKey {
                  id
                  calendarIds
                  externalEventId
                  orgId
                }
                recurringEventId
                recurrenceRules {
                  interval {
                    interval
                    freqType
                  }
                }
                guestsCanModify
                title
                createdMillis
                isClockwiseEvent
                organizer {
                  urnValue
                }
                startTime {
                  millis
                }
                endTime {
                  millis
                }
                annotatedEvent {
                  id
                  externalEventId
                  orgTags {
                    tag
                    state {
                      active
                      value
                    }
                  }
                }
              }
            }
            ... on GraphEntityError {
              message
            }
          }
        }
      }
    }
    webAppFlagsErrorable {
      __typename
      ... on GraphEntityError {
        statusCode
        message
      }
      ... on Flags {
        flags
      }
      ... on Node {
        __isNode: __typename
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
    } as any, v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "timeZone",
        "storageKey": null
    } as any, v3 = {
        "alias": null,
        "args": null,
        "concreteType": "WorkingSetting",
        "kind": "LinkedField",
        "name": "setting",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "minSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "maxSlot",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "excludedSlots",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v4 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v5 = [
        (v1 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateOrDateTime",
            "storageKey": null
        } as any,
        (v2 /*: any*/),
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "millis",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "offsetMinutes",
            "storageKey": null
        } as any
    ], v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "externalEventId",
        "storageKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "calendarIds",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "count",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tag",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "active",
        "storageKey": null
    } as any, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "value",
        "storageKey": null
    } as any, v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "subjectType",
        "storageKey": null
    } as any, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "subjectValue",
        "storageKey": null
    } as any, v14 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastModified",
        "storageKey": null
    } as any, v15 = {
        "alias": null,
        "args": null,
        "concreteType": "OrgTag",
        "kind": "LinkedField",
        "name": "orgTags",
        "plural": true,
        "selections": [
            (v9 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "TagState",
                "kind": "LinkedField",
                "name": "state",
                "plural": false,
                "selections": [
                    (v10 /*: any*/),
                    (v11 /*: any*/),
                    (v12 /*: any*/),
                    (v13 /*: any*/),
                    (v14 /*: any*/)
                ],
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any, v16 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryEmail",
        "storageKey": null
    } as any, v17 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isYou",
        "storageKey": null
    } as any, v18 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dayOffset",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeSlot",
            "storageKey": null
        } as any
    ], v19 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "DayOffsetTimeSlot",
            "kind": "LinkedField",
            "name": "minSlot",
            "plural": false,
            "selections": (v18 /*: any*/),
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "DayOffsetTimeSlot",
            "kind": "LinkedField",
            "name": "maxSlot",
            "plural": false,
            "selections": (v18 /*: any*/),
            "storageKey": null
        } as any
    ], v20 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
    } as any, v21 = {
        "kind": "InlineFragment",
        "selections": [
            (v20 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v22 = {
        "kind": "InlineFragment",
        "selections": [
            (v0 /*: any*/)
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    } as any, v23 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
    } as any, v24 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urnValue",
        "storageKey": null
    } as any, v25 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "profileId",
        "storageKey": null
    } as any, v26 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urnType",
        "storageKey": null
    } as any, v27 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "optional",
        "storageKey": null
    } as any, v28 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "organizer",
        "storageKey": null
    } as any, v29 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "resource",
        "storageKey": null
    } as any, v30 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "responseStatus",
        "storageKey": null
    } as any, v31 = [
        (v23 /*: any*/),
        (v25 /*: any*/),
        (v27 /*: any*/),
        (v28 /*: any*/),
        (v29 /*: any*/),
        (v30 /*: any*/),
        (v26 /*: any*/),
        (v24 /*: any*/)
    ], v32 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "statusCode",
                "storageKey": null
            },
            (v20 /*: any*/)
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "OneOnOneAutopilotQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "OneOnOneAutopilot_viewer"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "OneOnOneAutopilotQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v0 /*: any*/),
                                {
                                    "alias": null,
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 1000000
                                        }
                                    ],
                                    "concreteType": "OrgConnection",
                                    "kind": "LinkedField",
                                    "name": "orgs",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "OrgEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Org",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v0 /*: any*/),
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "domains",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "experiments",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "primaryOrgCalendar",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": [
                                                                {
                                                                    "kind": "Literal",
                                                                    "name": "resolveOverrides",
                                                                    "value": false
                                                                }
                                                            ],
                                                            "concreteType": "UserWorkingHours",
                                                            "kind": "LinkedField",
                                                            "name": "userWorkingHours",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "WorkingHours",
                                                                    "kind": "LinkedField",
                                                                    "name": "workingHours",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v0 /*: any*/),
                                                                        (v1 /*: any*/),
                                                                        (v2 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "DaySetting",
                                                                            "kind": "LinkedField",
                                                                            "name": "daySettings",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "day",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v3 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "DayOverride",
                                                                            "kind": "LinkedField",
                                                                            "name": "dayOverrides",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "date",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v3 /*: any*/)
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v0 /*: any*/)
                                                            ],
                                                            "storageKey": "userWorkingHours(resolveOverrides:false)"
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "focusTimeSavedInHours",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "primaryOrgEmail",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": null,
                                                            "kind": "LinkedField",
                                                            "name": "oneOnOnesForCalendar",
                                                            "plural": false,
                                                            "selections": [
                                                                (v4 /*: any*/),
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "Event",
                                                                            "kind": "LinkedField",
                                                                            "name": "list",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isAllDay",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "EventTime",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "startTime",
                                                                                    "plural": false,
                                                                                    "selections": (v5 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "EventTime",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "endTime",
                                                                                    "plural": false,
                                                                                    "selections": (v5 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "EventKey",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "eventKey",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v6 /*: any*/),
                                                                                        (v0 /*: any*/),
                                                                                        (v7 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "hashedCalendars",
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "orgId",
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": null,
                                                                                    "kind": "LinkedField",
                                                                                    "name": "eventFlexibilityErrorable",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v4 /*: any*/),
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "EventFlexibilityNew",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "list",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "flex",
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "flexString",
                                                                                                            "storageKey": null
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "type": "EventFlexibilityNewList",
                                                                                            "abstractKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "RecurrenceRules",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "recurrenceRules",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "EventTime",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "firstInstanceStartTime",
                                                                                            "plural": false,
                                                                                            "selections": (v5 /*: any*/),
                                                                                            "storageKey": null
                                                                                        },
                                                                                        (v2 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "IntervalDefinition",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "interval",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "interval",
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "byDay",
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "bySetPos",
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "freqType",
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                (v8 /*: any*/),
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "EventTime",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "untilTime",
                                                                                                    "plural": false,
                                                                                                    "selections": (v5 /*: any*/),
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        },
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "kind": "ScalarField",
                                                                                            "name": "cancelledInstances",
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "AnnotatedEvent",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "annotatedEvent",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v15 /*: any*/),
                                                                                        (v0 /*: any*/),
                                                                                        (v6 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": "UserTag",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "userTags",
                                                                                            "plural": true,
                                                                                            "selections": [
                                                                                                (v9 /*: any*/),
                                                                                                (v8 /*: any*/),
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "TagState",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "states",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        (v14 /*: any*/),
                                                                                                        (v12 /*: any*/),
                                                                                                        (v13 /*: any*/),
                                                                                                        (v10 /*: any*/),
                                                                                                        (v11 /*: any*/)
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "AnnotatedEvent",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "annotatedRecurringEvent",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v15 /*: any*/),
                                                                                        (v0 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "eventParentRelayId",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": null,
                                                                                    "kind": "LinkedField",
                                                                                    "name": "attendeePeople",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v4 /*: any*/),
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "Person",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "list",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        (v0 /*: any*/),
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "emails",
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        (v16 /*: any*/),
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "UserProfile",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "profile",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "givenName",
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "familyName",
                                                                                                                    "storageKey": null
                                                                                                                },
                                                                                                                {
                                                                                                                    "alias": null,
                                                                                                                    "args": null,
                                                                                                                    "kind": "ScalarField",
                                                                                                                    "name": "externalImageUrl",
                                                                                                                    "storageKey": null
                                                                                                                }
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        (v17 /*: any*/)
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "type": "PersonList",
                                                                                            "abstractKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": null,
                                                                                    "kind": "LinkedField",
                                                                                    "name": "suggestedAutopilotSettingsResponseV3",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v4 /*: any*/),
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "DayOffsetTimeSlotRange",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "intersectionOfAttendeesMeetingHours",
                                                                                                    "plural": false,
                                                                                                    "selections": (v19 /*: any*/),
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "SuggestedAutotpilotSettingsResponseV3CalendarIdMeetingHours",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "calendarIdToMeetingHours",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "calendarId",
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "DayOffsetTimeSlotRange",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "dayOffsetTimeSlotRanges",
                                                                                                            "plural": true,
                                                                                                            "selections": (v19 /*: any*/),
                                                                                                            "storageKey": null
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "SuggestedAutopilotSettingsV3",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "suggestedAutopilotSettings",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "isRoomFlexible",
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "movementType",
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "DayOffsetTimeSlot",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "allowedEndTime",
                                                                                                            "plural": false,
                                                                                                            "selections": (v18 /*: any*/),
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "DayOffsetTimeSlot",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "allowedStartTime",
                                                                                                            "plural": false,
                                                                                                            "selections": (v18 /*: any*/),
                                                                                                            "storageKey": null
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "type": "SuggestedAutopilotSettingsResponseV3",
                                                                                            "abstractKey": null
                                                                                        },
                                                                                        (v21 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": null,
                                                                                    "kind": "LinkedField",
                                                                                    "name": "moveRangeInLocalTimeV3",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v4 /*: any*/),
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "DayOffsetTimeSlot",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "allowedStartTimeInclusive",
                                                                                                    "plural": false,
                                                                                                    "selections": (v18 /*: any*/),
                                                                                                    "storageKey": null
                                                                                                },
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "DayOffsetTimeSlot",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "allowedEndTimeInclusive",
                                                                                                    "plural": false,
                                                                                                    "selections": (v18 /*: any*/),
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "type": "MoveRangeInLocalTimeV3",
                                                                                            "abstractKey": null
                                                                                        },
                                                                                        (v21 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "isClockwiseEvent",
                                                                                    "storageKey": null
                                                                                },
                                                                                (v7 /*: any*/),
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": null,
                                                                                    "kind": "LinkedField",
                                                                                    "name": "organizerPerson",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v4 /*: any*/),
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                (v17 /*: any*/),
                                                                                                (v16 /*: any*/)
                                                                                            ],
                                                                                            "type": "Person",
                                                                                            "abstractKey": null
                                                                                        },
                                                                                        (v22 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Attendee",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "attendees",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        (v23 /*: any*/),
                                                                                        (v24 /*: any*/),
                                                                                        (v25 /*: any*/),
                                                                                        (v26 /*: any*/),
                                                                                        (v27 /*: any*/),
                                                                                        (v28 /*: any*/),
                                                                                        (v29 /*: any*/),
                                                                                        (v30 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Attendee",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "creator",
                                                                                    "plural": false,
                                                                                    "selections": (v31 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Attendee",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "organizer",
                                                                                    "plural": false,
                                                                                    "selections": (v31 /*: any*/),
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "recurringEventId",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "title",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "transparency",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "guestsCanInviteOthers",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "guestsCanModify",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "guestsCanSeeOtherGuests",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "locked",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "privateCopy",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "description",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "location",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "etag",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "htmlLink",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "hangoutLink",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "kind": "ScalarField",
                                                                                    "name": "createdMillis",
                                                                                    "storageKey": null
                                                                                },
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": null,
                                                                                    "kind": "LinkedField",
                                                                                    "name": "featureStatesForOrganizer",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v4 /*: any*/),
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": null,
                                                                                                    "args": null,
                                                                                                    "concreteType": "MixedFreemiumOrgUiState",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "mixedFreemiumOrgUIState",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "autopilotPaused",
                                                                                                            "storageKey": null
                                                                                                        },
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "kind": "ScalarField",
                                                                                                            "name": "moveRangesEnabled",
                                                                                                            "storageKey": null
                                                                                                        }
                                                                                                    ],
                                                                                                    "storageKey": null
                                                                                                }
                                                                                            ],
                                                                                            "type": "FeatureStates",
                                                                                            "abstractKey": null
                                                                                        },
                                                                                        (v32 /*: any*/)
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "type": "EventList",
                                                                    "abstractKey": null
                                                                },
                                                                (v21 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": "orgs(first:1000000)"
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "webAppFlagsErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v4 /*: any*/),
                                        (v32 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "flags",
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "Flags",
                                            "abstractKey": null
                                        },
                                        (v22 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "91d605bd38be78f82c1e15cc284b2939",
            "id": null,
            "metadata": {},
            "name": "OneOnOneAutopilotQuery",
            "operationKind": "query",
            "text": "query OneOnOneAutopilotQuery {\n  viewer {\n    ...OneOnOneAutopilot_viewer\n    id\n  }\n}\n\nfragment AutopilotFlexibility_event on Event {\n  eventParentRelayId\n  attendeePeople {\n    __typename\n    ... on PersonList {\n      list {\n        id\n        emails\n        primaryEmail\n        profile {\n          givenName\n          familyName\n          externalImageUrl\n        }\n        isYou\n      }\n    }\n  }\n  eventKey {\n    id\n    externalEventId\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n        subjectValue\n        lastModified\n      }\n    }\n    id\n  }\n  annotatedRecurringEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n        subjectValue\n        lastModified\n      }\n    }\n    id\n  }\n  suggestedAutopilotSettingsResponseV3 {\n    __typename\n    ... on SuggestedAutopilotSettingsResponseV3 {\n      intersectionOfAttendeesMeetingHours {\n        minSlot {\n          dayOffset\n          timeSlot\n        }\n        maxSlot {\n          dayOffset\n          timeSlot\n        }\n      }\n      calendarIdToMeetingHours {\n        calendarId\n        dayOffsetTimeSlotRanges {\n          minSlot {\n            dayOffset\n            timeSlot\n          }\n          maxSlot {\n            dayOffset\n            timeSlot\n          }\n        }\n      }\n      suggestedAutopilotSettings {\n        isRoomFlexible\n        movementType\n        allowedEndTime {\n          dayOffset\n          timeSlot\n        }\n        allowedStartTime {\n          dayOffset\n          timeSlot\n        }\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n  moveRangeInLocalTimeV3 {\n    __typename\n    ... on MoveRangeInLocalTimeV3 {\n      allowedStartTimeInclusive {\n        dayOffset\n        timeSlot\n      }\n      allowedEndTimeInclusive {\n        dayOffset\n        timeSlot\n      }\n    }\n    ... on GraphEntityError {\n      message\n    }\n  }\n}\n\nfragment AutopilotFlexibility_org on Org {\n  userWorkingHours(resolveOverrides: false) {\n    workingHours {\n      id\n      type\n      timeZone\n      daySettings {\n        day\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n      dayOverrides {\n        date\n        setting {\n          minSlot\n          maxSlot\n          excludedSlots\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment EventSummaryAttendees_attendees on Attendee {\n  displayName\n  urnValue\n  profileId\n  urnType\n}\n\nfragment EventSummaryAttendees_org on Org {\n  id\n  domains\n}\n\nfragment EventSummaryAutopilotFlex_event on Event {\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n      }\n    }\n    id\n  }\n  annotatedRecurringEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n      }\n    }\n    id\n  }\n}\n\nfragment EventSummaryBestTimeRecurrence_event on Event {\n  startTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  endTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  recurrenceRules {\n    firstInstanceStartTime {\n      type\n      dateOrDateTime\n      timeZone\n      millis\n      offsetMinutes\n    }\n    timeZone\n    interval {\n      interval\n      byDay\n      bySetPos\n      freqType\n      count\n      untilTime {\n        type\n        dateOrDateTime\n        timeZone\n        millis\n        offsetMinutes\n      }\n    }\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n      }\n    }\n    id\n  }\n  annotatedRecurringEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n      }\n    }\n    id\n  }\n}\n\nfragment EventSummaryExternalAttendees_attendees on Attendee {\n  displayName\n  urnValue\n  profileId\n  urnType\n}\n\nfragment EventSummaryExternalAttendees_org on Org {\n  id\n  domains\n}\n\nfragment EventSummaryRecurrence_event on Event {\n  isAllDay\n  startTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  endTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  eventKey {\n    externalEventId\n    id\n  }\n  eventFlexibilityErrorable {\n    __typename\n    ... on EventFlexibilityNewList {\n      list {\n        flex\n        flexString\n      }\n    }\n  }\n  recurrenceRules {\n    firstInstanceStartTime {\n      type\n      dateOrDateTime\n      timeZone\n      millis\n      offsetMinutes\n    }\n    timeZone\n    interval {\n      interval\n      byDay\n      bySetPos\n      freqType\n      count\n      untilTime {\n        type\n        dateOrDateTime\n        timeZone\n        millis\n        offsetMinutes\n      }\n    }\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n      }\n    }\n    id\n  }\n}\n\nfragment EventSummaryRecurrence_org on Org {\n  id\n  primaryOrgCalendar\n}\n\nfragment EventSummaryRoom_attendees on Attendee {\n  displayName\n  urnValue\n}\n\nfragment EventSummaryTime_event on Event {\n  startTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  endTime {\n    type\n    dateOrDateTime\n    timeZone\n    millis\n    offsetMinutes\n  }\n  eventKey {\n    externalEventId\n    id\n  }\n  eventFlexibilityErrorable {\n    __typename\n    ... on EventFlexibilityNewList {\n      list {\n        flex\n        flexString\n      }\n    }\n  }\n  recurrenceRules {\n    firstInstanceStartTime {\n      type\n      dateOrDateTime\n      timeZone\n      millis\n      offsetMinutes\n    }\n    timeZone\n    interval {\n      interval\n      byDay\n      bySetPos\n      freqType\n      count\n      untilTime {\n        type\n        dateOrDateTime\n        timeZone\n        millis\n        offsetMinutes\n      }\n    }\n  }\n  annotatedEvent {\n    orgTags {\n      tag\n      state {\n        active\n        value\n        subjectType\n      }\n    }\n    id\n  }\n}\n\nfragment EventSummaryTime_org on Org {\n  id\n  primaryOrgCalendar\n}\n\nfragment OnboardingAutopilotEvent_event on Event {\n  ...EventSummaryRecurrence_event\n  ...EventSummaryTime_event\n  ...EventSummaryBestTimeRecurrence_event\n  ...EventSummaryAutopilotFlex_event\n  ...AutopilotFlexibility_event\n  isClockwiseEvent\n  calendarIds\n  eventKey {\n    id\n    calendarIds\n    externalEventId\n    hashedCalendars\n    orgId\n  }\n  organizerPerson {\n    __typename\n    ... on Person {\n      isYou\n      primaryEmail\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  attendees {\n    ...EventSummaryAttendees_attendees\n    ...EventSummaryExternalAttendees_attendees\n    ...EventSummaryRoom_attendees\n    displayName\n    profileId\n    optional\n    organizer\n    resource\n    responseStatus\n    urnType\n    urnValue\n  }\n  creator {\n    displayName\n    profileId\n    optional\n    organizer\n    resource\n    responseStatus\n    urnType\n    urnValue\n  }\n  endTime {\n    millis\n    timeZone\n    offsetMinutes\n  }\n  organizer {\n    displayName\n    profileId\n    optional\n    organizer\n    resource\n    responseStatus\n    urnType\n    urnValue\n  }\n  recurringEventId\n  recurrenceRules {\n    firstInstanceStartTime {\n      timeZone\n      offsetMinutes\n    }\n    timeZone\n    interval {\n      byDay\n      count\n    }\n    cancelledInstances\n  }\n  startTime {\n    millis\n    timeZone\n    offsetMinutes\n  }\n  title\n  transparency\n  isAllDay\n  guestsCanInviteOthers\n  guestsCanModify\n  guestsCanSeeOtherGuests\n  locked\n  privateCopy\n  description\n  location\n  etag\n  htmlLink\n  hangoutLink\n  annotatedEvent {\n    id\n    externalEventId\n    orgTags {\n      tag\n      state {\n        lastModified\n        subjectType\n        subjectValue\n        active\n        value\n      }\n    }\n    userTags {\n      tag\n      count\n      states {\n        lastModified\n        subjectType\n        subjectValue\n        active\n        value\n      }\n    }\n  }\n  createdMillis\n  featureStatesForOrganizer {\n    __typename\n    ... on FeatureStates {\n      mixedFreemiumOrgUIState {\n        autopilotPaused\n        moveRangesEnabled\n      }\n    }\n    ... on GraphEntityError {\n      statusCode\n      message\n    }\n  }\n}\n\nfragment OnboardingAutopilotEvent_org on Org {\n  id\n  domains\n  experiments\n  ...EventSummaryAttendees_org\n  ...EventSummaryExternalAttendees_org\n  ...EventSummaryRecurrence_org\n  ...EventSummaryTime_org\n  ...AutopilotFlexibility_org\n}\n\nfragment OneOnOneAutopilot_viewer on Viewer {\n  id\n  user {\n    id\n    orgs(first: 1000000) {\n      edges {\n        node {\n          ...OnboardingAutopilotEvent_org\n          id\n          experiments\n          focusTimeSavedInHours\n          primaryOrgEmail\n          primaryOrgCalendar\n          oneOnOnesForCalendar {\n            __typename\n            ... on EventList {\n              list {\n                ...OnboardingAutopilotEvent_event\n                moveRangeInLocalTimeV3 {\n                  __typename\n                  ... on MoveRangeInLocalTimeV3 {\n                    allowedStartTimeInclusive {\n                      dayOffset\n                      timeSlot\n                    }\n                    allowedEndTimeInclusive {\n                      dayOffset\n                      timeSlot\n                    }\n                  }\n                  ... on GraphEntityError {\n                    message\n                  }\n                }\n                eventKey {\n                  id\n                  calendarIds\n                  externalEventId\n                  orgId\n                }\n                recurringEventId\n                recurrenceRules {\n                  interval {\n                    interval\n                    freqType\n                  }\n                }\n                guestsCanModify\n                title\n                createdMillis\n                isClockwiseEvent\n                organizer {\n                  urnValue\n                }\n                startTime {\n                  millis\n                }\n                endTime {\n                  millis\n                }\n                annotatedEvent {\n                  id\n                  externalEventId\n                  orgTags {\n                    tag\n                    state {\n                      active\n                      value\n                    }\n                  }\n                }\n              }\n            }\n            ... on GraphEntityError {\n              message\n            }\n          }\n        }\n      }\n    }\n    webAppFlagsErrorable {\n      __typename\n      ... on GraphEntityError {\n        statusCode\n        message\n      }\n      ... on Flags {\n        flags\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '144ccb8a256c8ac776502ac030845412';
export default node;
